import { useState,useEffect,useRef } from "react";

import axios from "axios";
import MainLayout from "./layouts/MainLayout";
import ClientSelector from "./Client/ClientSelector";

function AddTicket() {

  const [clientId,setClientId]=useState("");
  const [clientName,setClientName] = useState("");

  const [technicianId,setTechnicianId]=useState("");
  const [managerId,setManagerId]=useState("");

  const [title,setTitle]=useState("");
  const [description,setDescription]=useState("");
  const [priority,setPriority]=useState("Medium");
  const [showClientPopup, setShowClientPopup] = useState(false);

  const clientInputRef = useRef(null);
  
  useEffect(()=>{

if(showClientPopup){

const handleEsc=(e)=>{

if(e.key==="Escape"){

setShowClientPopup(false);

setTimeout(()=>{

clientInputRef.current?.focus();

},100);

}

};

window.addEventListener(
"keydown",
handleEsc
);

return()=>{

window.removeEventListener(
"keydown",
handleEsc
);

};

}

},[showClientPopup]);

useEffect(()=>{

setTimeout(()=>{

clientInputRef.current?.focus();

},100);

},[]);

  const saveTicket=async(e)=>{

    e.preventDefault();

    try{

      const token=localStorage.getItem("token");

      const response=await axios.post(

      "https://saleupcall.com/api/add-ticket.php",

      {

        client_id:clientId,
        technician_id:technicianId || null,
        manager_id:managerId || null,

        title,
        description,
        priority

      },

      {

        headers:{

          Authorization:`Bearer ${token}`

        }

      }

      );

      console.log(response.data);

      if(response.data.status){

        alert(

        "Ticket Created : " +

        response.data.ticket_number

        );

        setClientId("");
        setTechnicianId("");
        setManagerId("");

        setTitle("");
        setDescription("");

        setPriority("Medium");

      }
      else{

        alert(
          response.data.message
        );

      }

    }
    catch(error){

      console.log(error);

    }

  };

  return(

    <MainLayout>

      <div style={{padding:"20px"}}>

        <h2>Create Ticket</h2>

        <form onSubmit={saveTicket}>

          
<input ref={clientInputRef} type="text" placeholder="Select Client" value={clientName} autoFocus onChange={()=>{}} onClick={()=>setShowClientPopup(true)}
onKeyDown={(e)=>{if(e.key==="Enter"){e.preventDefault(); setShowClientPopup(true); }}} />

          <br/><br/>

          <input
          type="text"
          placeholder="Technician ID"
          value={technicianId}
          onChange={(e)=>
          setTechnicianId(
          e.target.value
          )}
          />

          <br/><br/>

          <input
          type="text"
          placeholder="Manager ID"
          value={managerId}
          onChange={(e)=>
          setManagerId(
          e.target.value
          )}
          />

          <br/><br/>

          <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e)=>
          setTitle(
          e.target.value
          )}
          />

          <br/><br/>

          <textarea
          placeholder="Description"
          value={description}
          onChange={(e)=>
          setDescription(
          e.target.value
          )}
          />

          <br/><br/>

          <select
          value={priority}
          onChange={(e)=>
          setPriority(
          e.target.value
          )}
          >

          <option value="Low">

          Low

          </option>

          <option value="Medium">

          Medium

          </option>

          <option value="High">

          High

          </option>

          <option value="Critical">

          Critical

          </option>

          </select>

          <br/><br/>

          <button
          type="submit"
          >

          Create Ticket

          </button>

        </form>

      </div>
{
showClientPopup && (

<div
className="modal d-block"
style={{
background:"rgba(0,0,0,.5)"
}}
>

<div className="modal-dialog modal-xl">

<div className="modal-content">

<div className="modal-header">

<h5>Select Client</h5>

<button
className="btn-close"
onClick={()=>
setShowClientPopup(false)
}
></button>

</div>

<div className="modal-body">

<ClientSelector

onSelect={(client)=>{

setClientId(
client.id
);

setClientName(
client.name
);

setShowClientPopup(
false
);

}}

/>

</div>

</div>

</div>

</div>

)

}
    </MainLayout>

  );

}

export default AddTicket;